export default __webpack_public_path__ + "static/media/moto-front-fill.93508de2.svg";